export default __webpack_public_path__ + "img/e5fbe292dc44f16e22102c803a61f6ae.svg";